import React, {useContext,useEffect,useState} from 'react'
import {TextField, FormHelperText, Box ,Button,FormGroup,Select,makeStyles ,InputLabel,MenuItem,FormControl,RadioGroup,Radio,FormLabel} from "@material-ui/core";
import Axios from 'axios'
import Autocomplete from '@mui/material/Autocomplete';
import { createFilterOptions } from "@mui/material/Autocomplete";
import {AlertDialog} from '../../../componentes/MUI/AlertDialog'
import {hacerFoco} from  '../../../Helpers/utilidades-globales';
import {useContextoGlobal} from '../../../Context/contextoGlobal'
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import BadgeIcon from '@mui/icons-material/Badge';
import Main from '../../../componentes/Main'
import {Loader} from '../../../componentes/Loader'


/*
Ejemplo de autocomplete.
El array de opciones espera tener un id y un label

 <Autocomplete
      disablePortal
      id="combo-box-demo"
      options={[{id:1,label:'pepe'},{id:2,label:'chocho'}]}
      onChange={(event, value) =>handleChangeTipoSalida(event)}
      sx={{ width: 300 }}
      renderInput={(params) => <TextField {...params} label="Movie" />}
    />
*/

export const Encargado = ({setEncargado,ministros,encargado,paso_encargado_inicial_ok})=>{
    const [ministroSeleccionado,setMinistroSeleccionado]=useState(encargado ? {id:encargado?.id_pastor_uad,nombre:encargado?.nombreEncargado} :null)
    const [encargadoExterno,setEncargadoExterno]=useState(encargado ? encargado?.nombreEncargado : null)
    const [esUad,setEsUad]=useState(encargado ? encargado?.encargadoEsUad : false);
    const {snackbar} = useContextoGlobal();

    useEffect(()=>{

        if(esUad==true){
            // es el caso en que modifica el tipo de encargado a UAD
            setEncargadoExterno(null)
            setEncargado({encargadoEsUad:true,nombreEncargado:null,id_pastor_uad:null})
            setTimeout(() => {
                hacerFoco('enc-uad')
            }, 100);
        }
        
        if(esUad==false){
            
            // es el caso en que modifica el tipo de encargado a externo
            setMinistroSeleccionado(null)
            setEncargado({encargadoEsUad:false,nombreEncargado:null,id_pastor_uad:null})
            setTimeout(() => {
                hacerFoco('enc-externo')
            }, 100);
        }
    },[esUad]) // aquí es importante el orden de los efectos. Primero hacer las acciones correspondientes
                // a la selección de que tipo de encargado es, luego que ejecute los efectos
                // del cambio de encargado según si es uad (con id de pastor) o externo
                // si el useEffect esUad se ubica después del effect de ministroSeleccionado y
                // encargadoExterno primero se ejecutaban estos 2 últimos y luego pasaba al effect
                // esUad pisando los datos.

    useEffect(()=>{
        if(esUad==true){
            if(Number(ministroSeleccionado?.id)>0){
                setEncargado({encargadoEsUad:true,nombreEncargado:ministroSeleccionado?.nombre,id_pastor_uad:ministroSeleccionado?.id})
            }else{
                //es el caso en que eliminó el ministro UAD seleccionado previamente
                setMinistroSeleccionado(null)
                setEncargado({encargadoEsUad:true,nombreEncargado:null,id_pastor_uad:null})
            }
        }
       
    },[ministroSeleccionado])

    useEffect(()=>{

        if(esUad==false){
            if(encargadoExterno!=''){
                setEncargado({encargadoEsUad:false,nombreEncargado:encargadoExterno,id_pastor_uad:null})
            }else{
                //es el caso en que borra el ministro EXTERNO ingresado previamente
                setEncargadoExterno(null)
                setEncargado({encargadoEsUad:false,nombreEncargado:null,id_pastor_uad:null})
            }
        }
    },[encargadoExterno])

    const filterOptions = createFilterOptions({
        stringify: (option) => quitaracentos(option.label)
    });

    function quitaracentos(cadena)
{
	var chars={
		"á":"a", "é":"e", "í":"i", "ó":"o", "ú":"u",
		"à":"a", "è":"e", "ì":"i", "ò":"o", "ù":"u", "ñ":"n",
		"Á":"A", "É":"E", "Í":"I", "Ó":"O", "Ú":"U",
		"À":"A", "È":"E", "Ì":"I", "Ò":"O", "Ù":"U", "Ñ":"N"}
	var expr=/[áàéèíìóòúùñ]/ig;
	var res=cadena.replace(expr,function(e){return chars[e]});
	return res;
}

    const useStyle = makeStyles({
        select: {
            background: 'white',
            color:'black'
        }
      });

    const classes = useStyle();

    const changeOnblur = (e)=>{
        if(e.target.value.trim()==''){
            setEncargadoExterno(null)
        }
    }

    if(ministros.length==0){
        return  <Main center>
        <Loader open={true} 
           //children={<h1 width='300px'>123</h1>}
           texto='Cargando registros...'/>
        </Main>
    }
   
   

//if(encargado?.nombreEncargado==undefined){
if(paso_encargado_inicial_ok==false){
    return <>
        <h3>Encargado de la iglesia:</h3>
        <Box sx={{display:'flex',justifyContent:'space-evenly',alignItems:'center',flexDirection:'column'}}>
            <Box sx={{marginTop:'10px'}}>
                <Button startIcon={<BadgeIcon style={{color:'green'}}/>} color={ esUad==true ? 'primary' : 'error'} variant='contained' onClick={()=>setEsUad(true)}>Tiene credenciales UAD</Button>
            </Box>         
            <Box sx={{marginTop:'30px',marginBottom:'30px'}}>
                <Button startIcon={<NoAccountsIcon style={{color:'red'}}/>}  color={esUad==false ? 'primary' : 'error'} variant='contained' onClick={()=>setEsUad(false)}>No tiene credenciales UAD</Button>
            </Box>   
        </Box>
        <Campos esUad={esUad} encargadoExterno={encargadoExterno} setEncargadoExterno={setEncargadoExterno} ministroSeleccionado={ministroSeleccionado} setMinistroSeleccionado={setMinistroSeleccionado} changeOnblur={changeOnblur} datos={ministros}/>
   </>   
}  

return  <Box sx={{marginTop:'20px'}}>
    <div>
        <h3>Encargado de la iglesia <span className='c-obl'></span></h3>
        <FormHelperText className="Mui-error">{ (!encargadoExterno || encargadoExterno.trim()=='') && !ministroSeleccionado ? 'Seleccione un encargado UAD o escriba el nombre y apellido si no tiene credenciales UAD': ""}</FormHelperText>
        <Campos esUad={esUad} encargadoExterno={encargadoExterno} setEncargadoExterno={setEncargadoExterno} ministroSeleccionado={ministroSeleccionado} setMinistroSeleccionado={setMinistroSeleccionado} changeOnblur={changeOnblur} datos={ministros}/>
        <Box sx={{display:'flex',justifyContent:'end',marginTop:'10px'}}>
            <Button variant='text' style={{textTransform:'none',color:'blue'}} onClick={()=>setEsUad(!esUad)}>{esUad==true ? 'Si el encargado no tiene credenciales UAD haga clic aquí' : 'Si el encargado tiene credenciales UAD haga clic aquí'}</Button>
        </Box>

    </div> 
      
      {/*<AlertDialog
                titulo="Por favor indique si el encargado tiene credenciales UAD"
                open={!continuar}
                fullWidth={true}
                style={{background:'gray'}}
                procesarCancelar={finalizar}
                procesarResultado={esUad==null ? false : iniciarContinuar}
            ><>
            <p>esUad: {typeof(esUad)} continuar: {typeof(continuar)} {continuar===false ? 'fasle' : continuar===true ? 'true' :  'null'}</p>

            <Box sx={{display:'flex',justifyContent:'space-evenly'}}>
                <Button startIcon={<BadgeIcon style={{color:'green'}}/>} color={ esUad==true ? 'primary' : 'error'} variant='contained' onClick={()=>setEsUad(true)}>Si, tiene credenciales UAD</Button>
                <Button startIcon={<NoAccountsIcon style={{color:'red'}}/>}  color={esUad==false ? 'primary' : 'error'} variant='contained' onClick={()=>setEsUad(false)}>No, no tiene credenciales UAD</Button>
            </Box>
            <Campos esUad={esUad} encargadoExterno={encargadoExterno} setEncargadoExterno={setEncargadoExterno} ministroSeleccionado={ministroSeleccionado} setMinistroSeleccionado={setMinistroSeleccionado} changeOnblur={changeOnblur} datos={datos}/>
            </>
    </AlertDialog>*/}
</Box>
/*
return    <Box sx={{display:'flex',flexDirection:'column',alignItems:'center',textAlign:'left' }}>
  <button onClick={()=>formik.setFieldError('id_ministro','blabla')}>probar</button>
     <Autocomplete
        disablePortal
        fullWidth
        filterOptions={filterOptions} // se utiliza para manipular los campos de búsqueda
        id="ac-ministros"
    //    value = {values[item.name]!='' ? datos.filter(item=>item[0]==values[item.name]).map(item=>item[1])[0] : ''}
        value = {datos.filter(item=>item[0]==Number(formik.values['id_ministro'])).map(item=>item[1])[0]}
        options={datos.map(item=>{return {id:item[0],label:item[1]}})}
        onChange={(event, value) => customHandleChange(event,value)}
        sx={{ width: 300 }}
        renderInput={(params) => <TextField {...params} label={formik.values['id_ministro']==''? 'Seleccione un valor':'Encargado'} />}
        />
        <FormHelperText className="Mui-error">{formik.errors['id_ministro'] ? formik.errors['id_ministro'] : ""}</FormHelperText>

</Box>
*/
  }

const Campos = ({setMinistroSeleccionado,setEncargadoExterno,esUad,ministroSeleccionado,encargadoExterno,changeOnblur,datos})=>{
 return   <Box sx={{marginTop:'10px'}}>
    {esUad==true && <Autocomplete
          //multiple
          options = {datos}
          id='enc-uad'
          //disabled={encargadoExterno ? true : false}
          value={ministroSeleccionado}
          //style={{background: encargadoExterno ? 'gray' : ''}}
          onChange={(event,value)=>setMinistroSeleccionado(value)}
          isOptionEqualToValue={(option, value) => option.id === value.id} // es util cuando los valores son objetos y no simples textos
          //filterSelectedOptions={true} // solo para cuando es multiple
          getOptionLabel={(option) => option.nombre}
          renderInput={(params) => (
            <TextField
            {...params}
              variant="filled"
              label={ministroSeleccionado ? 'Encargado UAD' : "Seleccione el ministro UAD aquí"}
            />
          )}
      />}
      {esUad==false && <TextField 
                        //style={{background: ministroSeleccionado ? 'gray' : ''}} 
                        onBlur={changeOnblur} 
                        label={encargadoExterno ? 'Nombre y apellido del encargado externo': ''} 
                        //disabled={ministroSeleccionado ? true : false} 
                        fullWidth={true} 
                        type='text' 
                        id='enc-externo'
                        value={encargadoExterno || ''} 
                        placeholder='Nombre del encargado externo' 
                        onChange={(e)=>setEncargadoExterno(e.target.value.toUpperCase())}
                />}
      </Box>
}

